import React, {useState, useEffect} from "react";
import {
  LoaderContainer,
  ModalBackButton,
  ModalContainer,
} from "../../common/components/modules/modal/modalComponents";
import RegistrationBuilder from "../../authentication/components/registrationBuilder";
import PersonalInfoForm from "./PersonalInfoForm";
import Loader from "../../common/components/elements/Loader";
import Modal from "../../common/components/modules/modal/Modal";
import useUserProfile from "src/core/authentication/hooks/useUserProfile";
import Error from "../../common/components/elements/Error";
import useRouter from "src/core/common/hooks/useRouter";
import get from "lodash/get";
import AuthenticationRequiredComponent from "../../common/components/utils/AuthenticationRequiredComponent";
import {IdVerificationContext} from "src/integrations/identityVerification/components/IdentityVerificationContext";
import {VerificationStatus} from "src/integrations/identityVerification/constants";
import ManualReviewModal from "src/integrations/identityVerification/components/ManualReviewModal";
import {ErrorTags} from "src/core/api/errorHandlers";
import Title from "src/core/common/components/modules/Title";

function PersonalInfo({isOpen, closeModal}) {
  const [profileState, authApi] = useUserProfile();
  const [submitted, setSubmitted] = useState(false);

  const router = useRouter();
  const {query} = router;

  const error = get(query, "error");
  const errorTag = get(query, "tag");
  const closeOnSuccess = get(query, "close", false);

  const [builder] = useState(new RegistrationBuilder());

  const finish = () => {
    authApi.updateUser(builder.build());
    setSubmitted(true);
  };
  useEffect(() => {
    if (submitted && !profileState.loading && !profileState.error) {
      if (closeOnSuccess) {
        closeModal ? closeModal() : router.safeBack();
      } else {
        setSubmitted(false);
      }
    } else if (submitted && !profileState.loading && profileState.error) {
      setSubmitted(false);
    }
  }, [
    profileState.loading,
    profileState.error,
    submitted,
    closeOnSuccess,
    router,
    closeModal,
  ]);

  return (
    <IdVerificationContext.Consumer>
      {(value) => (
        <AuthenticationRequiredComponent
          authenticationFailAction={() => {
            router.safeBack();
          }}
        >
          {error &&
            errorTag === ErrorTags.DOCUMENTS &&
            value.idVerificationStatus === VerificationStatus.REVIEW && (
              <ManualReviewModal
                isOpen={isOpen}
                onCloseHandler={router.safeBack}
                onCompleteManualVerificationHandler={router.safeBack}
              />
            )}
          <Modal isOpen={isOpen} onRequestClose={closeModal}>
            <ModalBackButton onClick={router.safeBack} />
            <ModalContainer>
              {profileState.loading && (
                <LoaderContainer>
                  <Loader />
                </LoaderContainer>
              )}
              <Title>Personal Information</Title>
              {error && <Error style={{marginBottom: "16px"}}>{error}</Error>}
              <PersonalInfoForm
                builder={builder}
                onFinish={finish}
                hasErrors={Boolean(error)}
                errorTag={errorTag}
                verificationStatus={value.idVerificationStatus}
              />
            </ModalContainer>
          </Modal>
        </AuthenticationRequiredComponent>
      )}
    </IdVerificationContext.Consumer>
  );
}

export default PersonalInfo;
